import debounce from 'debounce';
import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
class ImagesCarousel extends HTMLElement {
  constructor() {
    super();
    // elements
    this.keenSlider = null;
    this.slider = this.querySelector('.keen-slider');
    this.prevSelector = '[data-action=prev]';
    this.nextSelector = '[data-action=next]';
    this.space = this.getAttribute('data-space') ? parseInt(this.getAttribute('data-space'), 10) : 16;
    this.refreshArrows = null; // Store reference to refreshArrows
  }
  connectedCallback() {
    // bindings
    this.bndHandleResize = debounce(this.handleResize.bind(this), 250);
    // events
    this.onLoad();
    window.addEventListener('resize', this.bndHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.bndHandleResize);
    if (this.keenSlider.destroy) this.keenSlider.destroy();
  }
  onLoad() {
    this.initKeen();
  }
  handleResize() {
    if (this.refreshArrows) {
      this.refreshArrows();
    }
  }
  initKeen() {
    if (!this.slider) return;
    this.keenSlider = new KeenSlider(this.slider, {
      loop: false,
      mode: 'free-snap',
      slides: {
        perView: 'auto',
        spacing: this.space
      },
      created: () => {
        this.slider.classList.add('is-ready');
      }
    }, [slider => {
      const next = this.querySelector(this.nextSelector);
      const prev = this.querySelector(this.prevSelector);
      const refreshArrows = () => {
        const details = slider.track.details;
        const current = details?.rel ?? 0;
        prev?.removeAttribute('disabled');
        next?.removeAttribute('disabled');
        if (current === 0 && slider.options.loop != true || slider.slides.length == 0) {
          prev?.setAttribute('disabled', 'disabled');
        }
        if (current >= details.maxIdx && slider.options.loop != true || slider.slides.length == 0) {
          next?.setAttribute('disabled', 'disabled');
        }
      };
      // Store reference to refreshArrows function
      this.refreshArrows = refreshArrows;
      slider.on('created', () => {
        refreshArrows();
        slider.container?.classList.add('is-ready');
        next?.addEventListener('click', () => {
          slider.next();
        });
        prev?.addEventListener('click', () => {
          slider.prev();
        });
      });
      slider.on('slideChanged', () => {
        refreshArrows();
        const details = slider.track.details;
        if (this.current) {
          this.current.textContent = details.rel + 1;
        }
      });
    }]);
  }
}
customElements.define('images-carousel', ImagesCarousel);